// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"721b30c9","391":"9363cf34","483":"3d2badc6","503":"5e9cf6e2","515":"2cb48f7a","712":"ffc5136f","808":"1b31441a","963":"4a17d7ae"}[chunkId] + ".chunk.css";
};